import QuoteOverviewDesktop from "./QuoteOverview.desktop";

export default QuoteOverviewDesktop;
